import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const getPackageName = (packageType: string): string => {
  const packageNames: Record<string, string> = {
    'game-highlight': 'Game Highlight',
    'tournament-weekend': 'Tournament Weekend',
    'recruiting-standard': 'Recruiting Showcase',
    'recruiting-signature': 'Recruiting Signature'
  };
  return packageNames[packageType] || 'Custom Package';
};

export const getPackageIcon = (packageType: string) => {
  switch (packageType) {
    case 'game-highlight': return '⚡';
    case 'tournament-weekend': return '🏆';
    case 'recruiting-standard': return '🎓';
    case 'recruiting-signature': return '⭐';
    default: return '📦';
  }
};
